import { IStatisticV2 as IContentfulStatisticV2 } from 'marketing-site/@types/generated/contentful'

export interface IStatistic {
  line1: string
  line2: string
}

export function transformStatistic({ fields }: IContentfulStatisticV2): IStatistic {
  return {
    ...fields,
  }
}
